import { useState, FC } from "react";
import { Switch } from "@headlessui/react";

export type ToggleProps = {
  state: boolean;
  disabled?: boolean;
  onChange?: (state: boolean) => void;
};

const ToggleUI: FC<ToggleProps> = ({ state, disabled = false, onChange }) => {
  const [enabled, setEnabled] = useState(state);

  const handleChange = (newState: boolean) => {
    setEnabled(newState);
    if (onChange) {
      onChange(newState);
    }
  };

  return (
    <Switch
      checked={enabled}
      onChange={handleChange}
      className="group relative inline-flex h-4 w-8 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2 data-[checked]:bg-primary-600"
      disabled={disabled}
    >
      <span className="sr-only">Use setting</span>
      <span
        aria-hidden="true"
        className="pointer-events-none inline-block h-3 w-3 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-4"
      />
    </Switch>
  );
};

export default ToggleUI;
